import React, { useEffect, useState } from 'react';
import './ToastNotification.css';

const ToastNotification = ({
  notification,
  onClose,
  onClick,
  duration = 5000,
  position = 'top-right'
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Trigger entrance animation
    setIsVisible(true);

    // Auto-dismiss timer
    const dismissTimer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(dismissTimer);
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) {
        onClose();
      }
    }, 300); // Match animation duration
  };

  const handleClick = () => {
    if (onClick) {
      onClick(notification);
    }
    handleClose();
  };

  const getIcon = () => {
    switch (notification.type) {
      case 'new_order':
        return '🔔';
      case 'order_cancelled':
        return '❌';
      case 'order_update':
        return '📦';
      case 'delivery_assigned':
        return '🚴';
      case 'order_delivered':
        return '✅';
      case 'preparing':
        return '👨‍🍳';
      case 'ready':
        return '✨';
      default:
        return '📢';
    }
  };

  const getTypeClass = () => {
    switch (notification.type) {
      case 'new_order':
        return 'toast-success';
      case 'order_cancelled':
        return 'toast-error';
      case 'order_update':
        return 'toast-info';
      default:
        return 'toast-info';
    }
  };

  if (!isVisible && !isExiting) {
    return null;
  }

  return (
    <div
      className={`toast-notification ${getTypeClass()} ${position} ${isExiting ? 'toast-exit' : 'toast-enter'}`}
      onClick={handleClick}
      role="alert"
      aria-live="polite"
    >
      <div className="toast-icon">{getIcon()}</div>
      <div className="toast-content">
        <div className="toast-title">{notification.title}</div>
        {notification.body && (
          <div className="toast-body">{notification.body}</div>
        )}
        {notification.orderId && (
          <div className="toast-order-id">Order #{notification.orderId.slice(-6)}</div>
        )}
      </div>
      <button
        className="toast-close"
        onClick={(e) => {
          e.stopPropagation();
          handleClose();
        }}
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
};

// Toast Container for managing multiple toasts
export const ToastContainer = ({ toasts, onRemove, onClick, position = 'top-right' }) => {
  return (
    <div className={`toast-container ${position}`}>
      {toasts.map((toast) => (
        <ToastNotification
          key={toast.id}
          notification={toast}
          onClose={() => onRemove(toast.id)}
          onClick={onClick}
          position={position}
        />
      ))}
    </div>
  );
};

export default ToastNotification;
